import { Either } from "monet";

/**
 * @description Запрос на создание заявки записи на прием.
 * @param {string} doctorId
 * @param {string} patientName
 * @param {string} patientPatronymic
 * @param {string} patientPhone
 * @param {string} patientSurname
 * @param {string} startsAt
 * @constructor
 */
export function CreateAppointmentRequest(
  doctorId,
  patientName,
  patientPatronymic,
  patientPhone,
  patientSurname,
  startsAt
) {
  /**
   * @description Получить представление запроса.
   * @returns {any}
   */
  this.toQuery = () => ({
    doctor_id: doctorId,
    patient_name: patientName,
    patient_patronymic: patientPatronymic,
    patient_phone: patientPhone,
    patient_surname: patientSurname,
    starts_at: startsAt,
  });
}

/**
 * @description Шлюз записей на прием.
 * @param {import('axios').AxiosStatic} axios
 * @constructor 
 */
export default function AppointmentGateway(axios) {
  /**
   * @description Создать заявку на прием к врачу.
   * @param {CreateAppointmentRequest} request Запрос.
   * @returns {Promise<Either>}
   */
  this.create = (request) => axios
    .post('/appointment-booking-widget-api/appointments', request.toQuery())
    .then(
      (response) => Either.right(response.data.data),
      (error) => {
        if (error.isAxiosError && error.response.status === 400) {
          return Either.left(error.response.data);
        }
        throw error;
      }
    );
  
  /**
   * @description Подтвердить заявку.
   * @param {string} confirmationId 
   * @param {string} code 
   * @returns {Promise<Either>}
   */
  this.confirm = (confirmationId, code) => axios
    .put(
      `/appointment-booking-widget-api/confirmations/${confirmationId}`,
      { code }
    )
    .then(
      (response) => Either.right(response.data.data),
      (error) => {
        if (error.isAxiosError && error.response.status === 400) {
          return Either.left(error.response.data);
        }
        throw error;
      }
    );
  /**
   * @description Переотправить код подтверждения.
   * @param {string} confirmationId
   * @returns {Promise<Either>}
   */
  this.resendConfirmationCode = (confirmationId) => axios
    .post(`/appointment-booking-widget-api/confirmations/${confirmationId}/resend`)
    .then(
      (response) => Either.right(response.data.data),
      (error) => {
        if (error.isAxiosError && [400, 404].includes(error.response.status)) {
          return Either.left(error.response.data);
        }
        throw error;
      }
    );
};